import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AppProvider } from './context/AppVarsContext';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PortalShell from './components/PortalShell';
import AccessDenied from './pages/AccessDenied';
import PortalSignIn from './pages/PortalSignIn';
import UserDirectory from './pages/UserDirectory';
import UserWorkspace from './pages/UserWorkspace';
import SuccessPage from './SuccessPage';
import ApplicationSignIn, { LIGHTBOX_APP_ID } from './pages/ApplicationSignIn';
import ResetPassword from './reset-password';
import PasswordReset from './password-reset';
import './App.css';

const DEFAULT_APP_ID = '43833997-5cc0-11eb-97b9-0ab31cf82f57';

const PasswordRoute = ({ children }) => {
  const appID = window.location.pathname.split('/').filter(Boolean)[1] || DEFAULT_APP_ID;
  return <AppProvider appid={appID}>{children}</AppProvider>;
};

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<PortalSignIn />} />
          <Route path={`/application/${LIGHTBOX_APP_ID}`} element={<ApplicationSignIn />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/access-denied" element={<AccessDenied />} />
          <Route path="/password-reset/:appid" element={<PasswordRoute><ResetPassword /></PasswordRoute>} />
          <Route path="/pwdreset/:appid/:uid" element={<PasswordRoute><PasswordReset /></PasswordRoute>} />
          <Route path="/admin" element={<ProtectedRoute><PortalShell /></ProtectedRoute>}>
            <Route path="users" element={<UserDirectory />} />
            <Route path="users/new" element={<UserWorkspace create />} />
            <Route path="users/:userid" element={<UserWorkspace />} />
          </Route>
          <Route path="*" element={<PortalSignIn />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
